import Select from "react-select";

export default function MultiSelectReactSelect({
  className = "",
  name,
  value = [],
  options = [],
  onChange,
  placeholder = "جستجو و انتخاب...",
  isDisabled = false,
}) {
  const handleSelectChange = (selectedOptions) => {
    onChange({
      target: {
        name,
        value: selectedOptions,
      },
    });
  };
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#a9dec4" : "#4b5563",
      borderWidth: "1px",
      borderRadius: "0.5rem",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(169, 222, 196, 0.5)" : "none",
      "&:hover": {
        borderColor: "#a9dec4",
      },
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#a9dec4"
        : state.isFocused
          ? "rgba(169, 222, 196, 0.2)"
          : "white",
      color: "#1f2937",
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: "rgba(169, 222, 196, 0.4)",
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: "#065f46",
      fontWeight: 500,
    }),

    multiValueRemove: (base) => ({
      ...base,
      color: "#065f46",
      ":hover": {
        backgroundColor: "#a9dec4",
        color: "#064e3b",
      },
    }),
  };
  return (
    <div className={className}>
      <Select
        /* 🔍 SEARCH */
        isSearchable={true}

        /* ✅ MULTI SELECT */
        isMulti

        /* UX بهتر */
        closeMenuOnSelect={false}
        hideSelectedOptions={false}

        options={options}
        value={value}
        onChange={handleSelectChange}
        placeholder={isDisabled ? "در حال بارگذاری..." : placeholder}
        isDisabled={isDisabled}

        noOptionsMessage={() => "موردی یافت نشد"}
        classNamePrefix="react-select"
        styles={customStyles}
      />
    </div>
  );
}
